
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { MeasurementSpecification } from '../../backend/backendapi';
import { unique } from '../../../util';

@Component
export default class MeasurementSpecificationsTemplateBadges extends Vue {
  @Prop({ required: true })
  readonly measurementSpecifications!: MeasurementSpecification[];

  get templateNames(): string[] {
    return unique(this.measurementSpecifications.map(e => e.templateName).filter(e => !!e).map(e => e!));
  }
}
